type Props = {
  x: number;
  y: number;
  rotation?: number;
  children?: React.ReactNode;
};

const Container = ({ x, y, rotation = 0, children }: Props) => {
  return (
    <container x={x} y={y} rotation={rotation}>
      {children}
    </container>
  );
};

export default Container;
